module.exports = __webpack_public_path__ + "img/zhangfushan.93839980.jpeg";